module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-h"
  }, [_c('span', [_vm._v("THE WITNESS")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left1"
  }, [_c('i', [_vm._v("I only am escaped alone to tell thee")]), _vm._v(" …")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("My thought")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("Darkened as by wind the water …")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left1"
  }, [_c('i', [_vm._v("There’s always")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("Someone has to tell them, isn’t there?…")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("Someone chosen by the chance of seeing")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("By the accident of sight")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("By the stumbling on the moment of it")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("Unprepared, unwarned, unready")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("Thinking of nothing … and it happens, and he sees it")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("Caught in that inextricable net")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("Of having witnessed, having seen …")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left1"
  }, [_c('i', [_vm._v("It was I")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("I only. I alone. The moment")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("Closed us together in its gaping grin")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("Of horrible incredulity")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("I only. I alone, to tell thee …")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("I who have understood nothing, have known")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("Nothing, have been answered nothing")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2d"
  }, [_vm._v("—Archibald MacLeish, "), _c('i', [_vm._v("J.B")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-left1"
  }, [_c('i', [_vm._v("God always wins")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2d"
  }, [_vm._v("—Archibald MacLeish, J.B.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a476794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part03.vue
// module id = 87
// module chunks = 0